import React from 'utils/react';
import { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import useTranslation from 'utils/react/useTranslation';
// import moment from 'moment-timezone';

import { DatePicker } from 'baseui/datepicker';
import { SIZE } from 'baseui/input';
import ja from 'date-fns/locale/ja';

import debug from 'utils/debug';
import { LOGISTICS_ROUTE } from 'utils/constants';
import Container from './Container';

const D2 = debug('p:Logistics:Panels:Footer');

const resources = {
  jp: ja,
  ja,
};

const formatStringsData = {
  jp: 'y年 M月 d日',
  en: 'dd/MM/yyyy',
  th: 'dd/MM/yyyy',
};

const formatStrings = {
  ...formatStringsData,
  ja: formatStringsData.jp,
};

const Footer = (props) => {
  const {
    isBookingsHidden,
    isServiceDataSource,
    serviceDate,
    setServiceDate,
    commuteOfferRequestUpdate,
    vehicles,
    projectData,
    setFleetData,
    setVehicleTypes,
    pageAddress,
  } = props;

  const { i18n } = useTranslation();

  const { language } = i18n;

  const timezone = global.GEODISC_TIMEZONE;

  const localeOverride = resources[language];
  const formatString = formatStrings[language];

  const [selectedDates, setSelectedDates] = useState(
    serviceDate ? [new Date(serviceDate)] : [new Date()]
  );
  const history = useHistory();
  const handleOnClick = useCallback(
    date =>
      history.push(
        pageAddress({
          page: LOGISTICS_ROUTE + '/routes',
          serviceDate: moment(date).tz(timezone).format('YYYY-MM-DD'),
          ...D2.CONTEXT,
        })
      ),
    [history]
  );

  useEffect(() => {
    const selectedDate = selectedDates[0];
    const date = selectedDate.toLocaleDateString('lt-LT');
    // console.log('*** Selected Date:', { date, selectedDate });
    setServiceDate(date);
    commuteOfferRequestUpdate(null, { isInitRequired: false, ...D2.CONTEXT });
    if (window.location.pathname === `${LOGISTICS_ROUTE}/routes`) {
      handleOnClick(selectedDates[0]);
    }
  }, [handleOnClick, selectedDates, commuteOfferRequestUpdate, setServiceDate]);

  const vehicleTypesList = projectData?.toJS()?.data?.vehicle_models;
  const vehiclesList = vehicles;

  useEffect(() => {
    // Load data to the fleet reducer from an existing selector
    // Using this method as a workaround until we drop 'reselect' and 'saga'
    setFleetData(vehicles);
    setVehicleTypes(vehicleTypesList, projectData?.toJS().modified_at);
  }, [setFleetData, setVehicleTypes, vehiclesList, vehicleTypesList]);

  const onDateChanged = value =>
    D2.S.FUNCTION('onDateChanged', { value }, () => {
      setSelectedDates([value]);
    });

  return isServiceDataSource ? (
    <Container isBookingsHidden={isBookingsHidden}>
      <DatePicker
        value={selectedDates}
        onChange={({ date }) =>
          Array.isArray(date) ? onDateChanged(date[0]) : onDateChanged(date)
        }
        locale={localeOverride}
        formatString={formatString}
        placeholder={formatString}
        mask={null}
        size={SIZE.compact}
      />
    </Container>
  ) : null;
};

export default Footer;
